/* eslint-env browser */

import * as React from 'react'
import { subscribe, publish } from '../../services/pub-sub'

const ReactDOM = require('react-dom')
const LoginForm = require('../../components/login-signup/LoginForm')
const SignupForm = require('../../components/login-signup/SignupForm')
const ShareModal = require('../../components/Modals/ShareModal')
const DomHelper = require('../../../../client/clientjs/dom-helper.js')

module.exports = () => {
  const modalLoginRenderElt = DomHelper.queryAll('#modal-login .modal-card .render-react')
  if (modalLoginRenderElt.length > 0) {
    ReactDOM.render(<LoginForm locale={window.initialState.locale.identifierShort} />, modalLoginRenderElt[0])
  }

  const modalSignupRenderElt = DomHelper.queryAll('#modal-signup .render-react')
  if (modalSignupRenderElt.length > 0) {
    ReactDOM.render(<SignupForm locale={window.initialState.locale.identifierShort} />, modalSignupRenderElt[0])
  }

  class ShareModalContainer extends React.Component {
    constructor(props) {
      super(props)
      this.state = { isActive: false, opts: {} }
      this.onHide = this.onHide.bind(this)
      subscribe('share-modal-open', ({ args: opts }) => {
        this.setState({
          isActive: true,
          opts,
        })
      })
    }

    onHide() {
      this.setState({ isActive: false, opts: {} })
    }

    render() {
      const { isActive, opts = {} } = this.state
      return (
        <ShareModal
          isActive={isActive}
          shareableLink={opts.shareableLink}
          host={window.initialState.config.host}
          onHide={this.onHide}
        />
      )
    }
  }

  const shareModalRenderElt = DomHelper.query('#share-modal-react-render')
  if (shareModalRenderElt) {
    ReactDOM.render(<ShareModalContainer />, shareModalRenderElt)
  }

  const openShareModals = DomHelper.queryAll('[data-share-link]')
  openShareModals.forEach(opener => {
    opener.onclick = function(e) {
      if (e && e.preventDefault) {
        e.preventDefault()
      }
      const link = DomHelper.data(opener, 'share-link')
      if (link) {
        publish('share-modal-open', {
          shareableLink: link,
        })
      }
    }
  })
}
